export default __webpack_public_path__ + "static/media/complaint-green.6634bab4.svg";